module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"This shop has no stock configured.":"Dieser Shop hat keine Lagerkonfiguration.","This Article has no stock.":"Dieser Artikel hat keinen Lagerbestand.","This Article is not assigned to any stock.":"Dieser Artikel ist keinem Lager zugeordnet.","Add article to a different stock":"Lagerbestand an einem anderen Ort hinzufügen","Add stock":"Lagerbestand hinzufügen"}}')
  delete Component.options._Ctor
}
